<template>
  <div class="">
    <ScheduleTable
      :editable="true"
      :schedule-obj="storeSchedule || {}"
      @change="handleScheduleChange"
      @input="handleInput"
    />
    <ModalButtons
      :reset="resetSchedule"
      :select="chooseSchedule"
      class="buttons-wrapper"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ScheduleTable from '@/components/Common/Scheduler/parts/SсheduleTable'
import ModalButtons from '@/components/Common/FilterModalButtons'
export default {
  name: 'Schedule',
  components: {
    ScheduleTable,
    ModalButtons
  },
  data() {
    return {
      schedule: null,
      scheduleStr: ''
    }
  },
  computed: {
    ...mapGetters({
      storeSchedule: 'search/searchSchedule'
    })
  },
  methods: {
    ...mapActions({
      setSchedule: 'search/SET_SCHEDULE'
    }),
    chooseSchedule() {
      this.$emit('clicked')
      this.setSchedule({
        schedule: this.schedule,
        scheduleStr: this.scheduleStr
      })
    },
    resetSchedule() {
      this.setSchedule({ schedule: null, scheduleStr: '' })
      this.schedule = null
      this.scheduleStr = ''
      this.$bus.$emit('clear.schedule')
    },
    handleScheduleChange(newSchedule) {
      this.schedule = newSchedule
    },
    handleInput(val) {
      this.scheduleStr = val
    }
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/variables';
.buttons-wrapper {
  padding: 10px 32px;
}

.table-container {
  box-shadow: none !important;
}
</style>
